import { usePunditUserContext } from "@circle-react/contexts";
import { useRevealingMessageStore } from "../stores/useRevealingMessageStore";
import type { ConversationChannel } from "../types/ConversationChannel";
import { QueueBanner } from "./QueueBanner";
import { Thinking } from "./common/Thinking";
import { ThinkingCard } from "./common/copilot/ThinkingCard";

interface ConversationViewLoadingStatesProps {
  channel: ConversationChannel | null;
  copilotLoadingText: string | null;
  isBotProcessing: boolean;
  isWaitingForConfirmation: boolean;
  isWaitingInQueue: boolean;
  onQueueComplete?: () => void;
  queuePosition: number | null;
}

export const ConversationViewLoadingStates = ({
  channel,
  copilotLoadingText,
  isBotProcessing,
  isWaitingForConfirmation,
  isWaitingInQueue,
  onQueueComplete,
  queuePosition,
}: ConversationViewLoadingStatesProps) => {
  const { currentCommunitySettings } = usePunditUserContext();
  const { isRevealing } = useRevealingMessageStore();

  const isCopilotV2Enabled = !!currentCommunitySettings?.copilot_v2_enabled;
  const isValidating = copilotLoadingText === "Validating...";
  const isShowingCopilotThinking =
    isCopilotV2Enabled &&
    !!copilotLoadingText &&
    !isWaitingForConfirmation &&
    (isValidating || !isRevealing);
  const isShowingThinking = isBotProcessing && !copilotLoadingText;
  const isShowingQueue = channel === "live_chat" && isWaitingInQueue;

  return (
    <>
      {isCopilotV2Enabled && (
        <ThinkingCard
          show={isShowingCopilotThinking}
          title={copilotLoadingText}
          onQueueComplete={onQueueComplete}
        />
      )}
      {(isShowingThinking || isShowingQueue) && (
        <div className="mt-4 flex flex-col">
          {isShowingThinking && <Thinking />}
          {isShowingQueue && queuePosition !== null && (
            <QueueBanner queuePosition={queuePosition} />
          )}
        </div>
      )}
    </>
  );
};
